import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
// import Icon from "@material-ui/core/Icon";
import CloudDownload from "@material-ui/icons/CloudDownload";
// import Link from "@material-ui/core/Link";
const styles = theme => ({
  para: {
    fontSize: 16
  },
  button: {
    margin: theme.spacing.unit,
    fontSize: 16
  },
  leftIcon: {
    marginRight: theme.spacing.unit
  },
  rightIcon: {
    marginLeft: theme.spacing.unit
  },
  imgdiv: {
    textAlign: "center",
    margin: "10px"
  },
  img: {
    borderRadius: "8px",
    border: "1px solid gray",
    width: "80%"
  }
});

const Solidworks = props => {
  const { classes } = props;
  return (
    <div>
      <Typography variant="h4">Solidworks</Typography>
      <Typography className={classes.para} paragraph>
        SolidWorks is a solid modeling computer-aided design (CAD) and
        computer-aided engineering (CAE) computer program that runs on Microsoft
        Windows. SolidWorks is published by Dassault Systèmes.
      </Typography>
      <Typography variant="h5">Stink-o-Meter</Typography>
      <Typography className={classes.para} paragraph>
        This is a 3D CAD model of partial body of a plastic man, made using
        Solidworks 2015. The hands will have gesture like shutting off nose with
        hand when stink is beyond threshold at public washrooms. The slots in
        the body will contain a sensor while disguising as button of shirt.
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./solidworks/Screenshot_3.png"
            alt="Schematic"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./solidworks/Screenshot_8.png"
            alt="Schematic"
          />
        </div>
        <div className={classes.imgdiv}>
          <img
            className={classes.img}
            src="./solidworks/Screenshot_10.png"
            alt="Schematic"
          />
        </div>
        <Button
          target="_blank"
          href={"./solidworks/body.SLDPRT"}
          variant="contained"
          size="small"
          color="primary"
          className={classes.button}
        >
          <CloudDownload className={classes.leftIcon} />
          Download file
        </Button>
      </Typography>
    </div>
  );
};

export default withStyles(styles)(Solidworks);
